export const KapeiLogo = ({ className = "" }) => (
  <div
    data-testid="kapei-logo"
    className={`inline-flex items-center gap-2 font-black tracking-tight ${className}`}
  >
    <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[#4d7c0f] text-white text-xl font-black">
      K
    </span>
    <span className="text-2xl">KAPEI</span>
  </div>
);

export default KapeiLogo;
